export default "__VITE_ASSET__6fa64401__"